import Page from "../page";

function Privacy() {
  return (
    <Page>
      <h1>Termes de confidentialité</h1>
      <h2>1.Collecte de l'information</h2>
      <p>
        Nous recueillons des informations lorsque vous vous inscrivez sur notre site, lorsque vous
        vous connectez à votre compte ou faites un achat. Les informations recueillies incluent
        votre nom, votre adresse e-mail, numéro de téléphone, et adresse pour la livraison.
      </p>
      <p>
        En outre, nous recevons et enregistrons automatiquement des informations à partir de votre
        ordinateur et navigateur, y compris votre adresse IP, vos logiciels et votre matériel, et la
        page que vous demandez.
      </p>
      <h2>2. Utilisation des informations</h2>
      <p>
        Toute les informations que nous recueillons auprès de vous peuvent être utilisées pour :
      </p>
      <ul>
        <li>Personnaliser votre expérience et répondre à vos besoins individuels</li>
        <li>Améliorer notre site Web</li>
        <li>Améliorer le service client et la prise en charge de vos commandes</li>
        <li>Vous contacter par e-mail</li>
        <li>Vous faire livrer vos commandes</li>
      </ul>
      <h2>3. Confidentialité du commerce en ligne</h2>
      <p>
        Nous sommes les seuls propriétaires des informations recueillies sur ce site. Vos
        informations personnelles ne seront pas vendues, échangées, transférées, ou données à une
        autre société pour n'importe quelle raison, sans votre consentement, en dehors de ce qui est
        nécessaire pour répondre à une demande et / ou une transaction, comme par exemple pour
        expédier une commande.
      </p>
      <h2>4. Divulgation à des tiers</h2>
      <p>
        Nous ne vendons, n'échangeons et ne transférons pas vos informations personnelles
        identifiables à des tiers. Cela ne comprend pas les tierces parties de confiance qui nous
        aident à exploiter notre site Web ou à mener nos affaires, tant que ces parties conviennent
        de garder ces informations confidentielles.
      </p>
      <p>
        Nous pensons qu'il est nécessaire de partager des informations afin d'enquêter, de prévenir
        ou de prendre des mesures concernant des activités illégales, fraudes présumées, situations
        impliquant des menaces potentielles à la sécurité physique de toute personne, violations de
        nos conditions d'utilisation, ou quand la loi nous y contraint.
      </p>
      <p>
        Les informations non-privées, cependant, peuvent être fournies à d'autres parties pour le
        marketing, la publicité, ou d'autres utilisations.
      </p>
      <h2>5. Protection des informations</h2>
      <p>
        Nous mettons en œuvre une variété de mesures de sécurité pour préserver la sécurité de vos
        informations personnelles. Nous utilisons un cryptage à la pointe de la technologie pour
        protéger les informations sensibles transmises en ligne. Nous protégeons également vos
        informations hors ligne. Seuls les employés qui ont besoin d'effectuer un travail spécifique
        (par exemple, la facturation ou le service à la clientèle) ont accès aux informations
        personnelles identifiables. Les ordinateurs et serveurs utilisés pour stocker des
        informations personnelles identifiables sont conservés dans un environnement sécurisé.
      </p>
      <p>Est-ce que nous utilisons des cookies ?</p>
      <p>
        Oui. Nos cookies améliorent l'accès à notre site et identifient les visiteurs réguliers. En
        outre, nos cookies améliorent l'expérience utilisateur grâce au suivi et au ciblage de ses
        intérêts. Cependant, cette utilisation des cookies n'est en aucune façon liée à des
        informations personnelles identifiables sur notre site.
      </p>
      <h2>6. Se désabonner</h2>
      <p>
        Nous utilisons l'adresse e-mail que vous fournissez pour vous envoyer des informations et
        mises à jour relatives à votre commande, des nouvelles de l'entreprise de façon
        occasionnelle, des informations sur des produits liés, etc. Si à n'importe quel moment vous
        souhaitez vous désinscrire et ne plus recevoir d'e-mails, des instructions de désabonnement
        détaillées sont incluses en bas de chaque e-mail.
      </p>
      <h2>7. Consentement</h2>
      <p>En utilisant notre site, vous consentez à notre politique de confidentialité.</p>
    </Page>
  );
}

export default Privacy;
